// First-use privacy consent modal for IDA voice input.
//
// Per design doc §6: audio is streamed to Azure Speech Services for real-time
// transcription, not stored server-side. We display the disclosure once per
// user-per-browser and persist their acceptance to localStorage.

import React from "react";
import { Box, Button, Modal, ModalDialog, Stack, Typography } from "@mui/joy";

interface VoiceInputPrivacyModalProps {
  open: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export const VoiceInputPrivacyModal: React.FC<VoiceInputPrivacyModalProps> = ({
  open,
  onAccept,
  onDecline,
}) => {
  return (
    <Modal open={open} onClose={onDecline}>
      <ModalDialog
        aria-labelledby="voice-input-privacy-title"
        aria-describedby="voice-input-privacy-body"
        size="md"
        sx={{ maxWidth: 480 }}
      >
        <Typography id="voice-input-privacy-title" level="title-lg">
          Voice input
        </Typography>
        <Box id="voice-input-privacy-body" sx={{ mt: 1 }}>
          <Typography level="body-md" sx={{ mb: 1 }}>
            When you use voice input, your microphone audio is streamed to
            Microsoft Azure Speech Services for real-time transcription.
          </Typography>
          <Typography level="body-md" sx={{ mb: 1 }}>
            Only the transcribed text reaches the assistant. Audio is not
            retained server-side after transcription.
          </Typography>
          <Typography level="body-sm" sx={{ color: "text.tertiary" }}>
            You can revoke microphone access at any time from your browser's
            site settings.
          </Typography>
        </Box>
        <Stack
          direction="row"
          spacing={1}
          justifyContent="flex-end"
          sx={{ mt: 2 }}
        >
          <Button variant="plain" color="neutral" onClick={onDecline}>
            Not now
          </Button>
          <Button onClick={onAccept}>I understand, enable voice</Button>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};
